import { errors } from 'rfc9457';

import { readEnvVariable } from '../helpers';

export interface ITelegramEnv {
  botToken: string;
  webhookSecret: string;
}

export function getTelegramEnv(): ITelegramEnv {
  const botToken = readEnvVariable('TELEGRAM_BOT_TOKEN');

  if (!botToken) {
    throw errors.server.envNotSet('TELEGRAM_BOT_TOKEN');
  }

  return {
    botToken,
    webhookSecret: readEnvVariable('TELEGRAM_WEBHOOK_SECRET'),
  };
}
